import { LevelEntity } from 'shared/domain/level/types/entity';
import { debugLog } from 'shared/logger/debugLog';
import { IssueEntity } from '../issue/entity';

export const createDocumentationIssuesMap = (
  issues: IssueEntity[],
  levels: LevelEntity[]
): Map<string, number> => {
  const docIssuesMap = new Map<string, number>();

  issues.forEach((issue) => {
    const levelId = issue.primaryData.level;
    const level = levels.find((l) => l._id === levelId);

    if (!level) {
      debugLog(
        'createDocumentationIssuesMap: Level not found for levelId:',
        levelId
      );
      return;
    }

    if (!level.maps || !Array.isArray(level.maps)) {
      debugLog('createDocumentationIssuesMap: Level has no maps:', level);
      return;
    }

    level.maps.forEach((mapItem) => {
      if (mapItem.documentationId) {
        const key = mapItem.documentationId;
        const currentCount = docIssuesMap.get(key) || 0;
        docIssuesMap.set(key, currentCount + 1);
      }
    });
  });

  return docIssuesMap;
};
